import { render } from "./ActivityContent.vue?vue&type=template&id=4a801807&scoped=true"
import script from "./ActivityContent.vue?vue&type=script&lang=js"
export * from "./ActivityContent.vue?vue&type=script&lang=js"

import "./ActivityContent.vue?vue&type=style&index=0&id=4a801807&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a801807"]])

export default __exports__